module.exports = __webpack_public_path__ + "img/1yWws8C230vCWk0RKkME65DBD4wnx1mhY.340fee61.jpg";